import { Box, useTheme } from "@mui/material";
import * as React from "react";

import { FileRecord } from "@/shared/domain/files";

interface ImageContentProps {
  fileRecord: FileRecord;
  signedUrl: URL | undefined;
}

export const ImageContent: React.FC<ImageContentProps> = ({
  fileRecord,
  signedUrl,
}) => {
  const theme = useTheme();
  const [showImage, setShowImage] = React.useState(false);

  /**
   * Note: (Pratik)
   * This is a heuristic to make subsequent image loads more seamless.
   * We assume that the next image loaded is the same aspect ratio as
   * the previous one so we optimistically display a loading skeleton with
   * this aspect ratio.
   *
   * A better approach is to obtain image width and height
   * information when fetching the image file from the server.
   */
  const [aspectRatio, setAspectRatio] = React.useState("3 / 2");

  return (
    <Box
      sx={{
        position: "relative",
        height: "100%",
      }}
    >
      <Box
        sx={{
          aspectRatio: aspectRatio,
          backgroundColor:
            theme.palette.mode === "dark" ? "#202020" : "#d6d6d6",
          position: "relative",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          height: "100%",
          margin: "auto",
          transition: "aspect-ratio 0.25s ease",
        }}
      ></Box>
      {signedUrl && (
        <img
          style={{
            display: "block",
            position: "absolute",
            height: "100%",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: "auto",
            opacity: showImage ? 1 : 0,
            transition: "opacity 0.5s ease-out",
          }}
          // loading = lazy is not strictly necessary because we only have one image to show but can help for future proofing
          loading="lazy"
          onLoad={(image) => {
            setShowImage(true);

            const newAspectRatio = `${image.currentTarget.naturalWidth} / ${image.currentTarget.naturalHeight}`;
            if (newAspectRatio !== aspectRatio) {
              setAspectRatio(newAspectRatio);
            }
          }}
          alt={fileRecord.relative_path}
          src={signedUrl?.toString()}
        />
      )}
    </Box>
  );
};
